/**
 * Class name merger — combines conditional classes and resolves Tailwind conflicts.
 *
 * Re-exports the same cn() from utils/cn/mergeClassNames.ts so that
 * imports throughout the codebase can use the shorter `@/lib/cn` path.
 */
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
